import React, { useContext } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Alert, Button, List, Modal, theme } from 'antd';

import Auth0RolesContext from '@totem/components/administration/auth0/roles/Auth0RolesContext';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';

const Auth0RolesSyncResultsModal = () => {
  const { token } = theme.useToken();
  const { showSyncResults, syncResult, onCloseSyncResults } =
    useContext(Auth0RolesContext);

  return (
    <Modal
      open={showSyncResults}
      onCancel={onCloseSyncResults}
      title={<ModalTitle>Sync Roles Result</ModalTitle>}
      styles={{ body: { maxHeight: '80vh', overflowY: 'auto' } }}
      footer={
        <ModalFooter>
          <Button type="primary" onClick={onCloseSyncResults}>
            Close
          </Button>
        </ModalFooter>
      }
    >
      <Alert
        style={{ marginBottom: 16 }}
        type={syncResult?.success ? 'success' : 'error'}
        showIcon
        message={syncResult?.success ? 'Roles synced' : 'Sync failed'}
        description={syncResult?.error || undefined}
      />

      <List
        size="small"
        bordered
        dataSource={syncResult?.steps ?? []}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                item.success ? (
                  <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                ) : (
                  <CloseCircleOutlined style={{ color: token.colorError }} />
                )
              }
              title={item.stepName}
              description={item.error || item.outcome}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default Auth0RolesSyncResultsModal;
